import * as React from "react";
import PropTypes from "prop-types";
import FormComponent from "../components/FormComponent";
import ModalSubHeaderComponent from "../components/ModalSubHeaderComponent";

export class FindInStoreFormPage extends React.Component {
  constructor(props) {
    super(props);
  }

  handleFormSelection = (postcode, color, sizes, accessories, selectedColourId) => {
    const { onFindInStoreClick } = this.props;
    onFindInStoreClick(sizes, postcode, accessories, color, selectedColourId);
  }

  render() {
    const { productName, selectedColor, selectedSizes, selectedAccessories, 
            postCode, initialDOMState, sizes, accessories, 
            selectedColourId } = this.props;
            
    return (
      <div className="find-in-store-form">
      <ModalSubHeaderComponent productName={productName}/>

        <div className="pure-g center">
          <div className="pure-u-1 form-container">
            <FormComponent
              initialDOMState={initialDOMState}
              onFormSubmit={this.handleFormSelection}
              showStoreAvailabilitySearchButton={true}
              sizes={sizes}
              accessories={accessories}
              selectedColor={selectedColor}
              selectedSizes={selectedSizes}
              selectedAccessories={selectedAccessories}
              postCode={postCode}
              selectedColourId ={selectedColourId}
            />
            <br />
          </div>
        </div>
      </div>
    );
  }
}

FindInStoreFormPage.propTypes = {
  onFindInStoreClick: PropTypes.func,
  productName: PropTypes.string
};

export default FindInStoreFormPage;
